import updateTree from './updateTree'

export default function profile(state = {}, action) {
  switch (action.type) {
    case 'SET_PROFILE': {
      return updateTree(state, 'profile', () => action.profile)
    }

    case 'SET_AUTHENTICITY_VERIFICATION': {
      return updateTree(state, 'authenticityVerificationState', () => action.state)
    }

    case 'SET_VEHICLES': {
      return updateTree(state, 'vehicles', () => action.vehicles)
    }

    case 'SET_ACCOUNT_SETTINGS': {
      return updateTree(state, 'accountSettings', () => action.settings)
    }

    case 'SET_FLAGS': {
      return updateTree(state, 'flags', () => action.flags)
    }

    case 'SET_DRIVER_ROUTE': {
      return updateTree(state, 'driverRoute', () => action.driverRoute)
    }

    case 'SET_TERMS_DOCUMENTS': {
      return updateTree(state, 'termsDocuments', () => action.termsDocuments)
    }

    case 'SET_DISCLOSURE_DOCUMENTS': {
      return updateTree(state, 'disclosureDocuments', () => action.disclosureDocuments)
    }

    case 'SET_DRIVER_HAS_ACTIVE_BLOCK': {
      return updateTree(state, 'driverHasActiveBlock', () => action.hasActiveBlock)
    }

    case 'SET_DRIVER_ACTIVE_BLOCK_STATUS': {
      return updateTree(state, 'driverActiveBlockStatus', () => action.status)
    }

    default:
      return {
        profile: null,
        authenticityVerificationState: null,
        vehicles: null,
        accountSettings: null,
        flags: [{}],
        termsDocuments: null,
        disclosureDocuments: null,
        driverHasActiveBlock: true,
        driverActiveBlockStatus: 'loading',
        ...state,
      }
  }
}
